<template>
  <div v-if="card && card.info && (card.info.total_evaluations_visibility || card.user_id !== user.id)">
    <div v-if="scope.row.scale.type">
      <click-to-edit
        v-if="scope.row.scale.type === scaleTypesEnum.TYPE_QUALITY"
        v-model="scope.row.scale.year_result"
        placeholder="Внесите результат"
        :disabled="!isFieldAvailableForEdit(scope.row, 'scale.year_result')"
        style="width: 100%"
        type="textarea"
        @input="saveElementPropChange(scope.row, 'scale', {year_result:$event})"
      ></click-to-edit>

      <click-to-edit
        v-else
        v-model="scope.row.scale.year_result"
        placeholder="Внесите результат"
        :disabled="!isFieldAvailableForEdit(scope.row, 'scale.year_result')"
        style="width: 100%"
        type="input"
        :number-format="{decimals: 3, space:true}"
        @input="saveElementPropChange(scope.row, 'scale', {year_result:$event})"
      ></click-to-edit>
    </div>


    <div
      v-else
      style="color: #b1b1b2;"
    >
      Сначала выберите тип цели
    </div>
  </div>
  <div
    v-else
    style="color: #b1b1b2;"
  >
    Скрыто
  </div>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
import {variables} from "@/componentsCompany/smz/variables";
import {mapGetters} from "vuex";
export default {
  name: 'element-year-result-chief-section-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {
      scaleTypesEnum: variables.scaleTypesEnum,
    }
  },
  computed: {
    ...mapGetters(['user']),
    ...mapGetters('card', {
      card: 'card',
    }),
    ...mapGetters('card/stages', {
      currentNegotiation: 'currentNegotiation',
    }),
  },
  methods: {

  }
}

</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";

</style>
